export const createHouseName = (house) => {
  const { building, corpus, streetName } = house;

  return [
    streetName?.trim(),
    building?.trim() && `д. ${building}`,
    corpus?.trim() && `к. ${corpus}`,
  ]
    .filter(Boolean)
    .join(', ');
};

export const createFlatKey = ({ typeId, name }) => `${typeId}_${name}`;
